export const SliderData = [
    {
        heading: 'The Last of Us',
        image: 'https://i.ibb.co/1dFRcX4/The-Last-of-Us-Part-1.jpg',
        desc: "Sony playstation's master PictureInPictureEvent, which is a remake of the 2013 game, The Last of us"
    },
    {
        heading: 'Deep Freezer',
        image: 'https://i.ibb.co/gMYfkJ3/Haier-Thermocool-chest-Feezer.jpg',
        desc: "The deep freezer offers ample storage space for preserving your favorite foods. With its efficient cooling system and durable design, it ensures long-lasting freshness and convenience for your kitchen needs."

    },
    {
        heading: "All Star Converse",
        image:  'https://i.ibb.co/nCNXyLh/P24-3-1.png',
        // image:  'https://i.ibb.co/7vX80gT/Ladies-Hand-Bag.jpg',
        desc: 'A fashionable canvas for both boys and girls, suitable for all occasions'
    },
    {
        heading: 'Fifa 23',
        image: 'https://i.ibb.co/6nvjFqx/p26.jpg',
        desc: "FIFA 23 delivers unparalleled soccer gaming experience with realistic gameplay, stunning graphics, and immersive modes. Compete with friends, build your dream team, and experience the thrill of the world's most popular sport"
    },
    {
        heading: 'Oculus Quest 2',
        image: 'https://i.ibb.co/NtkjCMB/p21.jpg',
        desc: 'Oculus Quest is a virtual Reality headset developed by Oculus. It is a device that can run games and software wirelessly under an Android based opating system.'
    },
    {
        heading: 'Xbox Series X',
        image: 'https://i.ibb.co/fNc7m4b/Xbox-Series-X.jpg',
        desc: 'The Xbox series X is a video game console developed by Microsoft. It happens to be part of the ninth generation of video game console.'
    },
]